import { trpc } from '../../lib/trpc';
import { FaRegTrashCan } from 'react-icons/fa6';
import { toast } from 'sonner';
import { ConfirmationModal } from '../helpers/ConfirmationModal';


interface DeleteQuizModalProps {
  isOpen: boolean;
  onClose: () => void;
  quizId: string;
  quizNumber: number;
}

export function DeleteQuizModal({ isOpen, onClose, quizId, quizNumber }: DeleteQuizModalProps) {
  const utils = trpc.useUtils();

  const deleteQuizMutation = trpc.admin.quiz.deleteQuiz.useMutation({
    onSuccess: () => {
      utils.admin.quiz.getQuizzes.invalidate();
      onClose();
      toast.success('Quiz deleted successfully!');
    },
    onError: (error) => {
      toast.error(`Failed to delete quiz: ${error.message}`);
    },
  });

  const handleDelete = () => {
    deleteQuizMutation.mutate({ id: quizId });
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleDelete}
      title="Delete Module Draft?"
      description="Your module draft will be deleted and you won't be able to restore it."
      confirmText="Delete"
      cancelText="Cancel"
      icon={
        <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center">
          <FaRegTrashCan className="w-9 h-9 text-red-500" />
        </div>
      }
      isLoading={deleteQuizMutation.isPending}
      highlightBox={{
        text: `Module ${quizNumber} (Draft)`,
      }}
    />
  );
}
